import SearchField from 'components/SearchField';
import { MuiDateRangePicker } from 'components/FormElements/DateRangePicker';
import PageFilters, { Filter } from 'components/PageFilters';
import { FirmSelector } from 'components/FirmSelector';
import { useGetRole } from 'hooks/ui/useGetRole';

type FiltersType = {
  firmId?: string;
  search?: string;
  startDate?: Date;
  endDate?: Date;
};

type Props = {
  filters: FiltersType;
  onFiltersChange: (filters: FiltersType) => void;
};

const BulkPaymentAssignmentFilters: React.FC<Props> = ({
  filters,
  onFiltersChange,
}) => {
  const { isSuperAdmin } = useGetRole();

  return (
    <PageFilters pageId="bulk-payment-assignment">
      {isSuperAdmin && (
        <Filter>
          <FirmSelector
            placeholder="Select firm"
            firmId={filters.firmId}
            onChange={(firmId) => {
              onFiltersChange({ firmId });
            }}
          />
        </Filter>
      )}
      <Filter>
        <SearchField
          variant="outlined"
          placeholder="Search by email, subscription ID or investor name"
          allowEmptyQuery
          autoSearchOnDebounce
          onSearch={(search: string) => onFiltersChange({ search })}
          fullWidth
        />
      </Filter>
      <Filter>
        <MuiDateRangePicker
          dateRange={{ startDate: filters.startDate, endDate: filters.endDate }}
          onDateRangeChange={({ startDate, endDate }) =>
            onFiltersChange({ startDate, endDate })
          }
          placeholder="Filter by subscription date"
        />
      </Filter>
    </PageFilters>
  );
};

export default BulkPaymentAssignmentFilters;
